import React from 'react';

/**
 * Creates a recharts Legend `formatter` function that wraps each legend label
 * in a span with a hover tooltip showing the definition.
 *
 * Usage:
 *   <Legend formatter={legendTooltipFormatter(definitions)} />
 *
 * where `definitions` is a Record<string, string> mapping legend name to tooltip text.
 */
export function legendTooltipFormatter(
  definitions: Record<string, string>
): (value: string) => React.ReactNode {
  return (value: string) => {
    const tooltip = definitions[value];
    if (!tooltip) return value;
    return (
      <span className="legend-tooltip-item">
        {value}
        <span className="legend-tooltip-text">{tooltip}</span>
      </span>
    );
  };
}
